module.exports = __webpack_public_path__ + "img/06.13d2baf3.jpg";